import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { fetchMarkets } from '../../services/marketService';
import { ArrowRight, BarChart2, Loader2 } from 'lucide-react';

import { MarketCard } from './MarketCard';

export const MarketGrid = () => {
    const navigate = useNavigate();
    const [markets, setMarkets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadMarkets = async () => {
            try {
                const data = await fetchMarkets();
                setMarkets(data);
            } catch (error) {
                console.error('Failed to load markets:', error);
            }
            setLoading(false);
        };
        loadMarkets();
    }, []);

    return (
        <section id="market-grid" className="py-24 bg-background">
            <div className="container mx-auto px-4">
                <div className="mb-12 flex flex-col md:flex-row md:items-center justify-between gap-6 border-b border-white/5 pb-10">
                    <div className="flex items-center gap-4">
                        <span className="text-3xl">📈</span>
                        <div>
                            <h2 className="text-2xl font-display font-black text-white uppercase tracking-tighter">Top Markets</h2>
                            <p className="text-[#6a6a6a] text-sm">Real-time prediction opportunities from Polymarket.</p>
                        </div>
                    </div>
                    <button
                        onClick={() => navigate('/markets')}
                        className="text-secondary text-xs font-bold uppercase tracking-widest hover:underline flex items-center gap-2 transition-colors"
                    >
                        View All Markets
                        <ArrowRight className="w-4 h-4" />
                    </button>
                </div>

                {loading ? (
                    <div className="flex items-center justify-center py-16">
                        <Loader2 className="w-8 h-8 text-primary animate-spin" />
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-6xl mx-auto">
                        {markets.map((market) => (
                            <MarketCard
                                key={market.id}
                                title={market.title}
                                volume={market.volume}
                                image={market.image}
                                chance={market.chance || market.long}
                                source={market.source}
                                validations={market.validations}
                                agentScore={market.agentScore}
                                disableClick={true}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};
